import { useMemo } from "react";

import { isTextEmpty } from "~components/cms/rich-text";
import type { PageContext } from "~lib/storyblok";

import type { BannerBlok, HeaderBlok } from "../types";

type Blok = (HeaderBlok & BannerBlok) | undefined;

const useHasGlobalBanner = (blok: Blok, context: PageContext) => {
  const hasBanner = useMemo(() => {
    const hasContent = !isTextEmpty(blok?.bannerText);

    // when we are on the page the banner is linking to, don't show it.
    const excludesCurrentPageLink =
      !blok?.bannerCTALink || blok.bannerCTALink.id !== context.uuid;

    return hasContent && excludesCurrentPageLink;
  }, [blok, context]);

  return { hasBanner };
};

export { useHasGlobalBanner };
